var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "chat-theme-settings" }, [
    _c("div", { staticClass: "page-header" }, [
      _c("div", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.$t("message.chatThemeSettings"))),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "subtitle" }, [
        _vm._v(_vm._s(_vm.$t("settings.chatThemeSettingsSubtitles"))),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "section",
      [
        _c("FeatureItem", {
          attrs: {
            title: _vm.$t("settings.visitorNew"),
            icon: "",
            description: _vm.$t("settings.visitorNewDesc"),
          },
          model: {
            value: _vm.isVersionV2,
            callback: function ($$v) {
              _vm.isVersionV2 = $$v
            },
            expression: "isVersionV2",
          },
        }),
        _vm._v(" "),
        _c("ChatThemeEditor", {
          attrs: { "update-settings": _vm.updateSettings },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }